/**
 * Preview-stage busy overlay + workspace lock (anti-misclick while generating).
 */

/**
 * @param {HTMLElement} root
 */
export function bindBusyOverlay(root) {
    const overlay = root.querySelector('#bag-studio-busy-overlay');
    const titleEl = overlay ? overlay.querySelector('[data-bag-busy-title]') : null;
    const detailEl = overlay ? overlay.querySelector('[data-bag-busy-detail]') : null;
    /** @type {Map<string, {title: string, detail: string}>} */
    const owners = new Map();

    function paint() {
        const visible = owners.size > 0;
        root.classList.toggle('is-busy', visible);
        root.setAttribute('aria-busy', visible ? 'true' : 'false');

        if (!overlay) {
            return;
        }

        const last = [...owners.values()].pop();
        if (titleEl) {
            titleEl.textContent = last ? last.title : '';
        }
        if (detailEl) {
            const detail = last ? last.detail : '';
            detailEl.textContent = detail;
            detailEl.hidden = !detail;
        }

        overlay.classList.toggle('d-none', !visible);
        overlay.hidden = !visible;
        overlay.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    return {
        /**
         * @param {string} owner
         * @param {string} title
         * @param {string} [detail]
         */
        show(owner, title, detail) {
            owners.set(owner, { title: title, detail: detail || '' });
            paint();
        },
        /**
         * @param {string} owner
         */
        hide(owner) {
            owners.delete(owner);
            paint();
        },
    };
}
